const defaultFonts = {
    Roboto: {
        family: 'Roboto',
        category: 'sans-serif',
        variants: ['100', '300', '400', '500', '700', '900'],
        subsets: ['cyrillic', 'cyrillic-ext', 'greek', 'greek-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    'Open-Sans': {
        family: 'Open Sans',
        category: 'sans-serif',
        variants: ['300', '400', '500', '600', '700', '800'],
        subsets: ['cyrillic', 'cyrillic-ext', 'greek', 'greek-ext', 'hebrew', 'latin', 'latin-ext', 'vietnamese']
    },
    Montserrat: {
        family: 'Montserrat',
        category: 'sans-serif',
        variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    Lato: {
        family: 'Lato',
        category: 'sans-serif',
        variants: ['100', '300', '400', '700', '900'],
        subsets: ['latin', 'latin-ext']
    },
    Poppins: {
        family: 'Poppins',
        category: 'sans-serif',
        variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        subsets: ['devanagari', 'latin', 'latin-ext']
    },
    'Source-Sans-Pro': {
        family: 'Source Sans Pro',
        category: 'sans-serif',
        variants: ['200', '300', '400', '600', '700', '900'],
        subsets: ['cyrillic', 'cyrillic-ext', 'greek', 'greek-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    Raleway: {
        family: 'Raleway',
        category: 'sans-serif',
        variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    'Noto-Sans': {
        family: 'Noto Sans',
        category: 'sans-serif',
        variants: ['400', '700'],
        subsets: ['cyrillic', 'cyrillic-ext', 'devanagari', 'greek', 'greek-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    Inter: {
        family: 'Inter',
        category: 'sans-serif',
        variants: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
        subsets: ['cyrillic', 'cyrillic-ext', 'greek', 'greek-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    Merriweather: {
        family: 'Merriweather',
        category: 'serif',
        variants: ['300', '400', '700', '900'],
        subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    'Playfair-Display': {
        family: 'Playfair Display',
        category: 'serif',
        variants: ['400', '500', '600', '700', '800', '900'],
        subsets: ['cyrillic', 'latin', 'latin-ext', 'vietnamese']
    },
    Oswald: {
        family: 'Oswald',
        category: 'sans-serif',
        variants: ['200', '300', '400', '500', '600', '700'],
        subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext', 'vietnamese']
    },
    'PT-Sans': {
        family: 'PT Sans',
        category: 'sans-serif',
        variants: ['400', '700'],
        subsets: ['cyrillic', 'cyrillic-ext', 'latin', 'latin-ext']
    }
};

export default defaultFonts;
